import ko from 'knockout';

export const localization = ko.observable<{
    timezone: string;
    country: string;
    dateformat: string;
    language: string;
    currency: { code: string };
}>();

export { localization as default };
